
import Vue from 'vue'

import RPHAccordion from 'rph/molecules/RPHAccordion/index.vue'
import { IProductTabs } from 'types/DTO/products'

/* Характеристики продукта */

export default Vue.extend({
  name: 'RPHProductSpecs',
  components: { RPHAccordion },
  computed: {
    productSpecs(): IProductTabs[] {
      return this.$store.getters['rph-products/annotations']
    },
  },
})
